import React from 'react';
import { IoFileTray, IoCheckmarkCircle } from 'react-icons/io5';
import { RequiredDocument } from '../types';

interface RequiredDocumentsProps {
  documents: RequiredDocument[];
}

const RequiredDocuments: React.FC<RequiredDocumentsProps> = ({ documents }) => {
  const getDocumentClassName = (doc: RequiredDocument) => {
    if (doc.uploaded) return 'document-uploaded';
    if (doc.optional) return 'document-optional';
    return 'document-pending';
  };

  const getDocumentMeta = (doc: RequiredDocument) => {
    if (doc.uploaded && doc.date && doc.size) {
      return `${doc.date} • ${doc.size}`;
    }
    if (doc.requiredBy) {
      return `Required by ${doc.requiredBy}`;
    }
    return 'Optional';
  };

  return (
    <div className="documents-section">
      <h4 className="documents-title">Required Documents</h4>
      <div className="documents-list">
        {documents.map((doc, index) => (
          <div
            key={index}
            className={`document-item ${getDocumentClassName(doc)}`}
          >
            <div className="document-icon-container">
              <IoFileTray className="document-icon" />
            </div>
            <div className="document-info">
              <h3 className="document-name">{doc.name}</h3>
              <p className="document-meta">{getDocumentMeta(doc)}</p>
            </div>
            {doc.uploaded ? (
              <IoCheckmarkCircle className="document-check-icon" />
            ) : (
              <button className="document-upload-button">Upload</button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default RequiredDocuments;